/**
 * token을 포함한 url 로 접근했을 때만 성공
 *   -> token이 없으면 접근제한
 *   -> token이 서버에서 유효하지 않으면 접근제한
 * 중간에 새로고침하면 처음부터 다시
 * 다 완료 했을 때 토큰 제거?
 *   ->
 */

import React, { createContext, useContext, useState } from "react";
import MainPage from "../pages/main/MainPage";
import OnBoardPage from "../pages/onboard/OnBoardPage";
import CardSelectPage from "../pages/cardSelect/CardSelectPage";
import OCRPage from "../pages/ocr/OCRPage";
import OCRResultPage from "../pages/ocr/OCRResultPage";
import FacePage from "../pages/face/FacePage";
import FaceResultPage from "../pages/face/FaceResultPage";
import ComplatePage from "../pages/complete/ComplatePage";
import phaseRouter, { T_Step } from "./PhaseRouter";

interface RouteContext {
  step: T_Step;
  navigate: (url: "next" | "prev") => void;
}

const Context = createContext<RouteContext | null>(null);

export const useRoutes = () => {
  const context = useContext(Context);
  if (!context) throw Error("context is null");
  return context;
};

const Router = () => {
  const [step, setStep] = useState(phaseRouter.step);

  const navigate = (nav: "next" | "prev") => {
    if (nav === "next") setStep(phaseRouter.next());
    if (nav === "prev") setStep(phaseRouter.prev());
  };

  return (
    <Context.Provider value={{ step, navigate }}>
      <>
        {step.current === "/main" && <MainPage />}
        {step.current === "/onboard" && <OnBoardPage />}
        {step.current === "/cardSelect" && <CardSelectPage />}
        {step.current === "/ocr" && <OCRPage />}
        {step.current === "/ocrResult" && <OCRResultPage />}
        {step.current === "/face" && <FacePage />}
        {step.current === "/faceResult" && <FaceResultPage />}
        {step.current === "/complete" && <ComplatePage />}
      </>
    </Context.Provider>
  );
};
export default Router;
